
export const handleRazorpayPayment = async ({
  amount,
  service,
  userData,
  fieldMap = {},
  http,
  formSubmitCallback,
}) => {

 
  try {

    const email = userData?.[fieldMap?.email] || userData?.user_email || userData?.user_email_address;
    const contact = userData?.[fieldMap?.contact] || userData?.user_contact_number || userData?.user_phone_number || userData?.user_contact ;
    const name = userData?.[fieldMap?.name] || userData?.user_name || userData?.full_name;
    
    

  console.log("Email:", email, "Contact:", contact, "Name:", name);
 


    const orderRes = await http.post('/create-order', {
      amount: amount, // check userData.prize first
      service_table: service.service_data_table,
      method: 'UPI',
      data:userData,   
      customer_email: email,
      customer_name: name,
      customer_contact: contact,
    });

  


    const orderData = orderRes.data;

    const options = {
      key: orderData.razorpay_key,
      amount: orderData.amount,
      currency: orderData.currency,
      name: 'DM2 Legal',
      description: 'Legal Service Payment',
      order_id: orderData.order_id,
      handler: async (response) => {
        const verifyRes = await http.post('/verify-payment', {
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature,
        });

        const paymentDetails = verifyRes.data.payment_details;

        await formSubmitCallback({
          ...userData,
          razorpay_payment_id: paymentDetails.razorpay_payment_id,
          razorpay_order_id: paymentDetails.razorpay_order_id,
          razorpay_signature: paymentDetails.razorpay_signature,
          amount: paymentDetails.amount,
          method: paymentDetails.method,
          currency: paymentDetails.currency,
        });

        alert('Payment successful!');
      },
      prefill: {
        name,
        email,
        contact,
      },
      theme: { color: '#528FF0' },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  } catch (error) {
    console.error('Payment failed:', error);
    alert('Something went wrong during the payment process.');
  }
};

